import {
  Box,
  Chip,
  createTheme,
  FormControl,
  FormLabel,
  Grid,
  Paper,
  TextField,
  ThemeProvider,
  Typography,
  useTheme,
} from "@material-ui/core";
import React, { useState } from "react";
import { PFXSubItemData } from "../../../../models/Interfaces";

import { useTranslation } from "react-i18next";
import "../../../../i18n/config";

interface ISubitemTextField {
  subitem: PFXSubItemData;
  setChosen: (value: string, id: string) => void;
  textFontFamily: string;
}

const SubitemTextField = ({ subitem, setChosen, textFontFamily }: ISubitemTextField) => {
  const [value, setValue] = useState<string>("");
  const [error, setError] = useState<boolean>(false);
  const id: string = React.useMemo(() => "text-option-" + Math.floor(Math.random() * 99999), []);

  const { t } = useTranslation("common");

  const theme = useTheme();

  const materialTheme = createTheme({
    ...theme,
    overrides: {
      ...theme.overrides,
      MuiButton: {
        textPrimary: { color: "#000" },
      },
      MuiInputBase: {
        root: {
          color: theme.palette.secondary.main,
        },
      },
      MuiIconButton: {
        root: {
          color: theme.palette.secondary.main,
        },
      },
      MuiOutlinedInput: {
        root: {
          "&:hover": {
            borderColor: `${theme.palette.secondary.main}aa !important`,
          },
        },
        notchedOutline: {
          borderColor: `${theme.palette.secondary.main} !important`,
          "&:hover": {
            borderColor: `${theme.palette.secondary.main}aa !important`,
          },
        },
      },
    },
  });

  return (
    <ThemeProvider theme={materialTheme}>
      <Grid item xs={12} key={`textfield-${subitem.id}`} style={{ margin: "5px 0px" }} className="subitem-render-div">
        <Paper>
          <Box p={2}>
            <FormControl component="fieldset" style={{ width: "100%" }}>
              <FormLabel component="legend" style={{ width: "100%", marginBottom: 5 }}>
                <Grid container justifyContent="flex-start">
                  <Typography variant="body1" style={{ fontFamily: textFontFamily }}>
                    {subitem.name}
                  </Typography>
                  {subitem.mandatory && (
                    <Chip
                      variant="outlined"
                      color="secondary"
                      size="small"
                      label={t("mandatory")}
                      style={{ marginLeft: 15 }}
                    />
                  )}
                </Grid>
              </FormLabel>
              <TextField
                error={error}
                variant="outlined"
                fullWidth
                value={value}
                onChange={e => {
                  if (error) {
                    setError(false);
                  }
                  setValue(e.target.value);
                }}
                onBlur={() => {
                  if (subitem.mandatory && value.trim() === "") {
                    setError(true);
                  } else {
                    setChosen(value, id);
                  }
                }}
              />
            </FormControl>
          </Box>
        </Paper>
      </Grid>
    </ThemeProvider>
  );
};

export default SubitemTextField;
